export default "__VITE_ASSET__BdZvC383__ 480w, __VITE_ASSET__B11dDu7z__ 768w, __VITE_ASSET__EOtrX0mr__ 1200w, __VITE_ASSET__DR_JXhDE__ 1920w";